export default function Privacy() {
  return (
    <div className="container page-animate pb-5" style={{ paddingTop: "140px" }}>
      <div className="row justify-content-center">
        <div className="col-lg-7">
          <div className="font-mono text-muted mb-4 pb-4 border-bottom border-secondary">
            DOCUMENT ID: PRIV-2026-05 &nbsp;|&nbsp; EFFECTIVE: {new Date().toLocaleDateString()}
          </div>
          <h1 className="fw-bold mb-5">Privacy Framework</h1>
          
          <p className="lead text-white mb-5">
            TapSecureX is engineered with a strict zero-knowledge architecture. Protection is our product, not your data.
          </p>

          <section className="mb-5">
            <h4 className="text-white mb-3">1. Non-Custodial Data Processing</h4>
            <p className="text-muted">
              TapSecureX operates a local VPN profile exclusively to route DNS traffic to the on-device filtering engine. <strong>We do not proxy, inspect, or log your actual web traffic payloads.</strong> The interface acts strictly as a localized DNS sinkhole.
            </p>
          </section>

          <section className="mb-5">
            <h4 className="text-white mb-3">2. Absolute DNS Anonymity</h4>
            <p className="text-muted">
              Unlike cloud-based resolvers (ISP DNS, public servers) that read and log every domain you visit, TapSecureX processes the resolution on your physical hardware. We do not transmit queries to our servers, and we maintain zero logs of your browsing history.
            </p>
          </section>

          <section className="mb-5">
            <h4 className="text-white mb-3">3. Cryptographic Updates</h4>
            <p className="text-muted">
              To defend against day-zero threats, the application periodically downloads updated signature files from the SentinelX API. These HTTP requests are completely anonymous and stripped of device identifiers (IMEI, Android ID).
            </p>
          </section>

          <section className="mb-5">
            <h4 className="text-white mb-3">4. Aggregate Diagnostics</h4>
            <p className="text-muted mb-0">
              We collect purely aggregate, non-identifiable crash analytics (e.g., "Engine initialization fault on OS 14") to ensure software stability. All diagnostic telemetry can be hard-disabled via the application settings menu.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}